import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { NgxMaskModule } from "ngx-mask";
import { FormContainersModule } from "src/app/ui-widgets/form-containers/form-containers.module";
import { HeaderModule } from "src/app/ui-widgets/header/header.module";
import { ModalsModule } from "src/app/ui-widgets/modals/modals.module";
import { SecureImageModule } from "src/app/ui-widgets/secure-image/secure-image.module";
import { SidebarEmptyModule } from "src/app/ui-widgets/sidebar-empty/sidebar-empty-module";
import { SidebarModule } from "src/app/ui-widgets/sidebar/sidebar.module";
import { AddPhotoComponent } from "./add-photo/add-photo.component";
import { AddPrescriptionComponent } from "./add-prescription/add-prescription.component";
import { AddressInfoComponent } from "./address-info/address-info.component";
import { ContactInfoComponent } from "./contact-info/contact-info.component";
import { SetupCompleteComponent } from "./setup-complete/setup-complete.component";
import { SignUpRoutingModule } from "./sign-up-routing-module";
import { SignUpComponent } from "./sign-up.component";
import { ComponentsModule } from "../components/components.module";

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        SignUpRoutingModule,
        HeaderModule,
        SidebarModule,
        SidebarEmptyModule,
        FormsModule,
        ReactiveFormsModule,
        SecureImageModule,
        FormContainersModule,
        NgxMaskModule.forRoot(),
        ModalsModule,
        ComponentsModule
    ],
    declarations: [
        SignUpComponent,
        AddPhotoComponent,
        AddPrescriptionComponent,
        AddressInfoComponent,
        ContactInfoComponent,
        SetupCompleteComponent
    ],
    exports: [
        SignUpComponent,
        AddPhotoComponent,
        AddPrescriptionComponent,
        AddressInfoComponent,
        ContactInfoComponent,
        SetupCompleteComponent
    ]
})
export class SignUpModule { }
